import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const MODIFY_ORG_ACCESS_SUCCESS = "ADMIN-USER:MODIFY_ORG_ACCESS_SUCCESS";

export interface ModifyOrgAccessSuccessAction extends Action {
  type: typeof MODIFY_ORG_ACCESS_SUCCESS;
  organization: OrganizationKeyName;
}

export const modifyOrgAccessSuccessAction = (
  organization: OrganizationKeyName
): ModifyOrgAccessSuccessAction => ({
  type: MODIFY_ORG_ACCESS_SUCCESS,
  organization,
});
